import { RESET_QUALIFY, UPDATE_QUALIFICATIONS } from '../../mutation-types';
import QualifyService, {
  getQualificationOnDemand,
} from '../../../services/qualify-service';

const actions = {
  getQualifications({ commit }, id) {
    return QualifyService.getQualifications(id).then((response) => {
      commit(UPDATE_QUALIFICATIONS, response.data);
    });
  },

  getQualificationOnDemand({ commit }, params) {
    return getQualificationOnDemand(params).then((response) => {
      commit(UPDATE_QUALIFICATIONS, response);
      return response;
    });
  },

  reset({ commit }) {
    commit(RESET_QUALIFY);
  },
};

export default actions;
